/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ToDoActionStatus {
    Open = 0,
    InProgress = 1,
    Completed = 2,
}
